import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isEmpty } from 'lodash';
import { Button } from 'reactstrap/lib';
import { connectToModel, bindToPath } from 'client/data/luckdragon/redux/react-binding';
import { DealerInfoEntities } from 'client/data/models/dealer-info';
import { LocationModel } from 'client/data/models/location';
import { weekdays } from 'client/utils/weekdays';
import { Collapse } from 'site-modules/shared/components/collapse/collapse';
import { DealerWorkTimeStatus } from './dealer-working-time-status';

import './dealer-details-work-hours.scss';

const WORK_HOURS_LIST_ID = 'dd-work-hours-list';

export function WorkDay(props) {
  const { currentDay, dayName, timeRange } = props;
  const isCurrentDay = currentDay.toLowerCase() === dayName.toLowerCase();
  return (
    <div
      key={dayName}
      className={classNames('work-day-row clearfix', { 'work-day-row-current fw-bold': isCurrentDay })}
    >
      <div className="work-day-name text-capitalize">{dayName}</div>
      <div className="work-day-range">{timeRange}</div>
    </div>
  );
}

WorkDay.propTypes = {
  currentDay: PropTypes.string,
  dayName: PropTypes.string,
  timeRange: PropTypes.node,
};

WorkDay.defaultProps = {
  currentDay: '',
  dayName: '',
  timeRange: '',
};

export class DealerDetailsWorkHoursUI extends Component {
  static propTypes = {
    currentDay: PropTypes.string,
    workHours: DealerInfoEntities.WorkHours,
    showHoursInHalfColumn: PropTypes.bool,
    dealerLocation: PropTypes.shape({
      gmtOffset: PropTypes.number,
      dst: PropTypes.string,
    }),
  };

  static defaultProps = {
    currentDay: '',
    workHours: null,
    showHoursInHalfColumn: false,
    dealerLocation: null,
  };

  state = {
    workHoursAreOpen: false,
  };

  /**
   * Get day work hours range string, e.g. 09:00 AM — 09:00 PM
   * @param dayName string
   */
  getCurrentDayRange = dayName => {
    const day = this.props.workHours[dayName.toLowerCase()];
    if (!day) return 'closed';
    return (
      <span>
        <span className="text-nowrap">{day.open}</span> - <span className="text-nowrap">{day.close}</span>
      </span>
    );
  };

  toggleWorkHoursRanges = () => {
    this.setState({
      workHoursAreOpen: !this.state.workHoursAreOpen,
    });
  };

  render() {
    const { currentDay, showHoursInHalfColumn, workHours, dealerLocation } = this.props;
    const { workHoursAreOpen } = this.state;

    if (isEmpty(workHours)) {
      return null; // the dealer hasn't set up working hours so don't this module shouldn't be displayed
    }

    const currentRange = this.getCurrentDayRange(currentDay);
    return (
      <div className="dealer-details-work-hours pos-r">
        {!showHoursInHalfColumn && <div className="current-day">Today {currentRange}</div>}
        <div className="d-flex">
          {dealerLocation && (
            <DealerWorkTimeStatus
              dealerLocation={dealerLocation}
              currentDay={currentDay}
              workHours={workHours}
              className={classNames('me-1', {
                'd-block': showHoursInHalfColumn,
                'd-inline-block': !showHoursInHalfColumn,
              })}
            />
          )}
          <Button
            color="link"
            className="px-0 py-0 small text-transform-none text-underline"
            onClick={this.toggleWorkHoursRanges}
            data-tracking-id="ddp_view_dealer_hours"
            aria-expanded={workHoursAreOpen}
            aria-controls={WORK_HOURS_LIST_ID}
          >
            Hours
            <span
              className={classNames(
                { 'icon-arrow-up2': workHoursAreOpen, 'icon-arrow-down2': !workHoursAreOpen },
                'ms-0_25'
              )}
              aria-hidden
            />
          </Button>
        </div>
        <Collapse
          id={WORK_HOURS_LIST_ID}
          isOpen={workHoursAreOpen}
          className={classNames('work-hours-list', { 'py-0_5': workHoursAreOpen })}
          transition="0.25s ease-in-out"
        >
          {weekdays.map(dayName => (
            <WorkDay
              key={dayName}
              currentDay={currentDay}
              dayName={dayName}
              timeRange={this.getCurrentDayRange(dayName)}
            />
          ))}
        </Collapse>
      </div>
    );
  }
}

export const stateToPropsConfig = {
  dealerLocation: bindToPath(({ dealerZip }) => `zips["${dealerZip}"]`, LocationModel),
};

export const DealerDetailsWorkHours = connectToModel(DealerDetailsWorkHoursUI, stateToPropsConfig);
